import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../api/v1";
import { ApiResponse } from "../../../../../types/api-response";
import axios from "../../../../../utils/axiosInceptor";

type GenerateTorResponse = {
  documentId: string;
};

type GenerateTorRequestOptions = {
  pdcId: string;
  source?: string;
};

const generateTorRequest = async (options: GenerateTorRequestOptions) => {
  const { pdcId, source } = options;

  const url = `${apiV1Endpoint}/booking/generateTorInvoice`;
  const payload = {
    pdcId,
    ...(source && { source }),
  };

  const response = await axios.post<ApiResponse<GenerateTorResponse>>(url, payload);
  return response.data;
};

type UseSendInvoiceRequestOptions = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useGenerateTorRequest = (options: UseSendInvoiceRequestOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: generateTorRequest,
    onSuccess,
    onError,
  });

  return {
    generateTorRequest: mutateAsync,
    isPendingGenerateTorRequest: isPending,
  };
};
